module.exports = __webpack_public_path__ + "img/100_KMSAT45_2022_Background.382f7e59.png";